import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import { ElementType, NumberFormat,} from '../Enums/constants';


export const PabsUkMembersTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <p>
          You may find it helpful to have your scheme's report and accounts on
          hand to provide the following data. If a member had multiple records
          (e.g., because of a broken service history) then include the member
          multiple times (i.e., include the total number of accounts).
        </p>

        <SurveySection labelText='Active members'>
          <SurveyElement
            questionNumber='9'
            labelText='Active members at the beginning of your scheme year'
            name='ActiveMemberslastyear'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Add:'
            pageName='Membership'
          />
          <SurveyElement
            labelText='New active members'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name='NewActivesExcludeRehires'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Less:'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Retirement from active'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name='UKActiveRetirement'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Others leaving active status'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name='UKActiveOthersLeaving'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Total leaving'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name='UKActiveLeaving'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Active members at the end of your scheme year'
            inputType={ElementType.CALCULATED}
            format={NumberFormat.INTEGER}
            formula='ActiveMemberslastyear + NewActivesExcludeRehires - UKActiveLeaving'
            pageName='Membership'
            name='ActiveMembers'
          />
        </SurveySection>

        <SurveySection labelText='Pensioners'>
          <SurveyElement
            questionNumber='10'
            labelText='Pensioners including dependents at the beginning of your scheme year'
            name='AnnuitantsLastYear'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Add:'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Total new pensioners'
            inputType={ElementType.NUMBER}
            name='UKPensionerNew'
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Less:'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Total pension cessations'
            inputType={ElementType.NUMBER}
            name='UKPensionerLeaving'
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Pensioners including dependents at the end of your scheme year'
            name='Annuitants'
            format={NumberFormat.INTEGER}
            inputType={ElementType.CALCULATED}
            formula='AnnuitantsLastYear + UKPensionerNew - UKPensionerLeaving'
            pageName='Membership'
          />
        </SurveySection>

        <SurveySection labelText='Deferred members'>
          <SurveyElement
            questionNumber='11'
            labelText='Deferred members at the beginning of your scheme year'
            name='inactiveMemberslastyear'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Add:'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Total new deferreds'
            inputType={ElementType.NUMBER}
            name='UKDeferredNew'
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Less:'
            pageName='Membership'
          />
          <SurveyElement
            labelText='Retirement from deferred'
            inputType={ElementType.NUMBER}
            name='UKDeferredRetirement'
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Other leaving deferred status'
            inputType={ElementType.NUMBER}
            name='UKDeferredOthersLeaving'
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Total leaving'
            inputType={ElementType.NUMBER}
            name='UKDeferredLeaving'
            format={NumberFormat.INTEGER}
            pageName='Membership'
          />
          <SurveyElement
            labelText='Deferred members at the end of your scheme year'
            name='InactiveMembers'
            format={NumberFormat.INTEGER}
            formula='inactiveMemberslastyear + UKDeferredNew - UKDeferredLeaving'
            inputType={ElementType.CALCULATED}
            pageName='Membership'
          />
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}